
import React, { useState } from 'react';
import { apiFetch, setAuthToken, setRole } from './api';

function LoginScreen({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);
      
      const res = await apiFetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData
      });
      
      if (res.ok) {
        const data = await res.json();
        setAuthToken(data.access_token);
        setRole(data.role);
        onLoginSuccess();
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('Connection error');
    }
  };

  return (
    <div className="home-screen" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
      <div className="card" style={{maxWidth: '400px', width: '100%', padding: '40px'}}>
        <h2>maculy Login</h2>
        <form onSubmit={handleLogin} style={{display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '30px'}}>
          <input 
            type="text" 
            placeholder="Username" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            style={{padding: '10px', borderRadius: '4px', border: '1px solid #444', background: '#222', color: 'white'}}
          />
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            style={{padding: '10px', borderRadius: '4px', border: '1px solid #444', background: '#222', color: 'white'}}
          />
          {error && <p style={{color: '#fa5252'}}>{error}</p>}
          <button type="submit" className="btn-primary">Login</button>
        </form>
      </div>
    </div>
  );
}

export default LoginScreen;
